import { Flex, Text, Heading } from "@chakra-ui/react";
import { textSecondary, newBorder } from "../../../utils/colors";
import StatusBadge from "../../../components/badges/StatusBadge";
import useIsMobile from "../../../hooks/useIsMobile";
import { useTranslation } from "react-i18next";

const TreatmentPlanHeaderPublic = ({ treatmentPlan }) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <Flex direction="column" p={["1rem 1.5rem 0", "1rem 0 0"]}>
      <Flex
        align="center"
        justify={["space-between", "flex-start"]}
        mb="0.5rem"
      >
        <Flex direction={["column", "row"]} align={["initial", "center"]}>
          <Heading fontSize={["sm", "sm"]} fontWeight="600">
            {t("treatmentPlan.treatmentPlan")}
          </Heading>
          <Flex
            bg={newBorder}
            h="16px"
            w="1px"
            mx="0.5rem"
            display={["none", "display"]}
          />
          <Text fontSize="sm" fontWeight="600" ml={[0, 1]} mr={[0, 4]}>
            {treatmentPlan &&
              treatmentPlan.treatmentPlanID &&
              treatmentPlan.treatmentPlanID}
          </Text>
        </Flex>
        <StatusBadge
          status={treatmentPlan.status}
          options="treatmentPublic"
          isSmall
        />
      </Flex>

      <Flex direction="column" m="0.5rem 0 0" fontSize="0.8rem">
        <Flex align="center">
          <Text fontSize="0.8rem" color={textSecondary} fontWeight="500">
            {t("patient.patient")}:
          </Text>
          <Text ml={2} fontWeight="500">
            {treatmentPlan &&
              treatmentPlan.patient &&
              treatmentPlan.patient.firstName +
                " " +
                treatmentPlan.patient.lastName}
          </Text>
        </Flex>

        {treatmentPlan &&
          treatmentPlan.patient &&
          treatmentPlan.patient.phone && (
            <Flex align="center">
              <Text color={textSecondary} fontWeight="500">
                {t("form.phone")}:
              </Text>
              <Text ml={2} fontWeight="500">
                {treatmentPlan &&
                  treatmentPlan.patient &&
                  treatmentPlan.patient.phone}
              </Text>
            </Flex>
          )}

        {treatmentPlan &&
          treatmentPlan.patient &&
          treatmentPlan.patient.email && (
            <Flex align="center">
              <Text color={textSecondary} fontWeight="500">
                {t("form.email")}:
              </Text>
              <Text ml={2} fontWeight="500">
                {treatmentPlan &&
                  treatmentPlan.patient &&
                  treatmentPlan.patient.email}
              </Text>
            </Flex>
          )}

        {treatmentPlan &&
          treatmentPlan.coordinator &&
          treatmentPlan.coordinator.firstName &&
          treatmentPlan.coordinator.lastName && (
            <Flex align="center">
              <Text color={textSecondary} fontWeight="500">
                {t("patient.planCoordinatorPublicLabel")}:
              </Text>
              <Text ml={2} fontWeight="500">
                {treatmentPlan.coordinator.firstName[0] +
                  "." +
                  treatmentPlan.coordinator.lastName}
              </Text>
            </Flex>
          )}
        {/* 
        {isMobile && (
          <Flex align="center">
            <Text color={textSecondary} fontWeight="500">
              {t("treatmentPlan.updatedAt")}:
            </Text>
            <Text ml={2} fontWeight="500" textTransform="capitalize">
              {treatmentPlan && treatmentPlan?.updatedAt
                ? dayjs(treatmentPlan?.updatedAt).format("YYYY MMMM DD")
                : "N/A"}
            </Text>
          </Flex>
        )} */}
      </Flex>
    </Flex>
  );
};

export default TreatmentPlanHeaderPublic;
